import { HttpHeaders } from '@angular/common/http';

export const RESPONSE_AS_TEXT_X_WWW = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
    }),
    observe: 'response' as 'body',
    responseType: 'text' as 'text',
};
